import {Component, OnInit, Input} from '@angular/core';
import {DataHandlerService} from '../../../services/data-handler.service';
import {Validators} from '@angular/forms';
import {take} from 'rxjs/operators';
import {MatButtonModule} from '@angular/material/button';
import {NgClass, NgIf} from '@angular/common';
import {MatInputModule} from '@angular/material/input';


@Component({
  selector: 'app-further-advance-confirmation',
  templateUrl: './further-advance-confirmation.component.html',
  standalone: true,
  imports: [
    MatButtonModule,
    NgIf,
    NgClass,
    MatInputModule
  ]
})
export class FurtherAdvanceConfirmationComponent implements OnInit {
  @Input() public formGroup: any;
  @Input() public widgetName: any;
  public confirmedComponents: any = [];

  constructor(public dataHandlerService: DataHandlerService) {
  }

  ngOnInit() {
    this.dataHandlerService.getConfirmedComponent()
      .subscribe((components) => {
        if (components) {
          console.log('getConfirmedComponent', components);
          this.confirmedComponents = components;
        }
      });

    if (this.formGroup && this.widgetName) {
      this.setupFaForm(this.widgetName);

      if (this.formGroup.get('faDataCheck').value) {
        this.confirmDetails(this.widgetName);
      }
    }
  }

  setupFaForm(widgetName) {
    this.formGroup.get('faDataCheck').setValidators(Validators.required);
    this.formGroup.get('faDataCheck').updateValueAndValidity();

    this.dataHandlerService.getConfirmedComponent()
      .pipe(take(1))
      .subscribe((components) => {
        if (components && components.includes(widgetName)) {
          this.formGroup.get('faDataCheck').patchValue(true, {emitEvent: false});
        }
      });
  }

  confirmDetails(widgetName) {
    if (!this.confirmedComponents.includes(widgetName)) {
      this.confirmedComponents.push(widgetName);
      this.formGroup.get('faDataCheck').patchValue(true);

      sessionStorage.setItem('confirmed-components', JSON.stringify(this.confirmedComponents));
    }
  }
}
